import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/LanguageContext";

import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import StateServicePage from "@/pages/StateServicePage";
import BlogIndex from "@/pages/BlogIndex";
import BlogCategory from "@/pages/BlogCategory";
import BlogArticle from "@/pages/BlogArticle";

// Smooth momentum scroll + scroll-to-top on route change
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:serviceSlug/:stateSlug" element={<StateServicePage />} />
          <Route path="/services/:serviceSlug" element={<ServicePage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/category/:catSlug" element={<BlogCategory />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" theme="dark" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
